const PropTypes = require('prop-types');
const React = require('react');
const BankTransferWarning = require('components/shop/bank_transfer_warning.jsx');
const CurrencyExchangeFeeWarning = require('components/shop/currency_exchange_fee_warning.jsx');
const LayawayWarning = require('components/shop/layaway_warning.jsx');
const classNames = require('classnames');

const CurrencyWarnings = function (props) {
  const showBankTransferWarning = props.payoutCurrency !== props.defaultCurrencyForBankCountry;
  const showCurrencyExchangeFeeWarning = props.payoutCurrency !== props.shopCurrency;

  if (!showBankTransferWarning && !showCurrencyExchangeFeeWarning) {
    return false;
  }

  const bankTransferWarningClassNames = classNames({
    small: true,
    'mb-half': showCurrencyExchangeFeeWarning,
  });

  return (
    <div className="alert alert-warn alert-small">
      <BankTransferWarning
        payoutCurrency={props.payoutCurrency}
        defaultCurrencyForBankCountry={props.defaultCurrencyForBankCountry}
        className={bankTransferWarningClassNames}
        nameForField={props.nameForField}
      />

      <CurrencyExchangeFeeWarning
        payoutCurrency={props.payoutCurrency}
        shopCurrency={props.shopCurrency}
        dashboardView={props.dashboardView}
        className="small"
        directCheckoutSelected
      />

      <LayawayWarning
        payoutCurrency={props.payoutCurrency}
        shopCurrency={props.shopCurrency}
        hasLayawayEnabled={props.hasLayawayEnabled}
        className="small"
        directCheckoutSelected
      />
    </div>
  );
};

CurrencyWarnings.propTypes = {
  payoutCurrency: PropTypes.string.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  defaultCurrencyForBankCountry: PropTypes.string.isRequired,
  dashboardView: PropTypes.bool,
  nameForField: PropTypes.func.isRequired,
  className: PropTypes.string,
  hasLayawayEnabled: PropTypes.bool.isRequired,
};

module.exports = CurrencyWarnings;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/currency_warnings.jsx